module.exports = __webpack_public_path__ + "assets/img/Type BS (17).8a97d0dd.jpg";